export default __webpack_public_path__ + "static/media/13.861a02a4.jpg";